// routes
import Iconify from 'src/components/iconify';
import { PATH_DASHBOARD } from '../../../routes/paths';

import { ICONS } from 'src/components/minimals-icons';
import { Features } from 'src/auth/fbac';

// ----------------------------------------------------------------------

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'dashboards',
    items: [
      {
        title: 'home',
        path: PATH_DASHBOARD.general.home,
        icon: ICONS.banking,
      },
      {
        title: 'reports',
        path: PATH_DASHBOARD.general.reports,
        icon: ICONS.analytics,
      },
      {
        title: 'canvassing',
        path: PATH_DASHBOARD.general.canvassing,
        icon: ICONS.label,
        features: [Features.CanvassingQA],
      },
      // {
      //   title: 'reports',
      //   path: PATH_DASHBOARD.reports.root,
      //   icon: <ChartBarIcon />,
      //   children: [
      //     { title: 'team', path: PATH_DASHBOARD.reports.team },
      //     { title: 'polling', path: PATH_DASHBOARD.reports.polling },
      //     { title: 'canvassing', path: PATH_DASHBOARD.reports.canvassing },
      //     { title: 'calling', path: PATH_DASHBOARD.reports.calling },
      //     { title: 'texting', path: PATH_DASHBOARD.reports.texting },
      //   ],
      // },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'action',
    items: [
      // CONTACTS (CRM)
      {
        title: 'contacts',
        path: PATH_DASHBOARD.crm.root,
        icon: ICONS.user,
        features: [Features.Crm],
      },

      // LISTS
      {
        title: 'lists',
        path: PATH_DASHBOARD.lists.root,
        icon: ICONS.menuItem,
      },

      // MESSAGING
      {
        title: 'messages',
        path: PATH_DASHBOARD.messaging.root,
        icon: ICONS.chat,
      },

      // PROJECTS
      {
        title: 'projects',
        path: PATH_DASHBOARD.general.projects,
        icon: ICONS.external,
      },

      // SETTINGS
      // {
      //   title: 'settings',
      //   path: PATH_DASHBOARD.settings.root,
      //   icon: <Cog6ToothIcon width={18} height={18} />,
      //   children: [
      //     { title: 'team', path: PATH_DASHBOARD.settings.team },
      //     { title: 'account', path: PATH_DASHBOARD.settings.root },
      //     { title: 'organization', path: PATH_DASHBOARD.settings.organization },
      //   ],
      // },
    ],
  },

  // SETTINGS
  // ----------------------------------------------------------------------
  {
    subheader: 'manage',
    items: [
      // DATA
      {
        title: 'data',
        path: PATH_DASHBOARD.data.root,
        icon: ICONS.alignLeft,
      },
      {
        title: 'team',
        path: PATH_DASHBOARD.settings.team,
        icon: ICONS.user,
      },
      {
        title: 'settings',
        path: PATH_DASHBOARD.settings.root,
        icon: <Iconify icon="solar:settings-bold-duotone" width={24} height={24} />,
      },
      {
        title: 'campaigns',
        path: PATH_DASHBOARD.campaigns.root,
        icon: ICONS.booking,
        features: [Features.Campaigns],
      },
      // {
      //   title: 'help center',
      //   path: 'https://intercom.help/numinar/en/',
      //   icon: <Iconify icon="solar:question-circle-bold" width={24} height={24} />,
      // },
    ],
  },

  // {
  //   subheader: 'more',
  //   items: [
  //     {
  //       title: 'Help & Support',
  //       path: 'https://intercom.help/numinar/en/',
  //       icon: <QuestionMarkCircleIcon width={18} height={18} />,
  //     },
  //     {
  //       title: 'Feature Request',
  //       path: 'https://numinar.productlane.io/roadmap',
  //       icon: <BoltIcon width={18} height={18} />,
  //     },
  //     {
  //       title: "What's New",
  //       path: 'https://numinar.productlane.io/changelog',
  //       icon: <BellIcon width={18} height={18} />,
  //     },
  //   ],
  // },

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     // {
  //     //   title: 'mail',
  //     //   path: PATH_DASHBOARD.messaging.root,
  //     //   icon: ICONS.mail,
  //     //   info: <Label color="error">+32</Label>,
  //     // },
  //     {
  //       title: 'chat',
  //       path: PATH_DASHBOARD.conversations.root,
  //       icon: ICONS.chat,
  //     },
  //     // {
  //     //   title: 'calendar',
  //     //   path: PATH_DASHBOARD.calendar,
  //     //   icon: ICONS.calendar,
  //     // },
  //     // {
  //     //   title: 'kanban',
  //     //   path: PATH_DASHBOARD.kanban,
  //     //   icon: ICONS.kanban,
  //     // },
  //   ],
  // },

  // DEMO MENU STATES
  // {
  //   subheader: 'Other cases',
  //   items: [
  //     {
  //       // default roles : All roles can see this entry.
  //       // roles: ['user'] Only users can see this item.
  //       // roles: ['admin'] Only admin can see this item.
  //       // roles: ['admin', 'manager'] Only admin/manager can see this item.
  //       // Reference from 'src/guards/RoleBasedGuard'.
  //       title: 'item_by_roles',
  //       path: PATH_DASHBOARD.permissionDenied,
  //       icon: ICONS.lock,
  //       roles: ['admin'],
  //       caption: 'only_admin_can_see_this_item',
  //     },
  //     {
  //       title: 'menu_level',
  //       path: '#/dashboard/menu_level',
  //       icon: ICONS.menuItem,
  //       children: [
  //         {
  //           title: 'menu_level_2a',
  //           path: '#/dashboard/menu_level/menu_level_2a',
  //         },
  //         {
  //           title: 'menu_level_2b',
  //           path: '#/dashboard/menu_level/menu_level_2b',
  //           children: [
  //             {
  //               title: 'menu_level_3a',
  //               path: '#/dashboard/menu_level/menu_level_2b/menu_level_3a',
  //             },
  //             {
  //               title: 'menu_level_3b',
  //               path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b',
  //               children: [
  //                 {
  //                   title: 'menu_level_4a',
  //                   path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b/menu_level_4a',
  //                 },
  //                 {
  //                   title: 'menu_level_4b',
  //                   path: '#/dashboard/menu_level/menu_level_2b/menu_level_3b/menu_level_4b',
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       title: 'item_disabled',
  //       path: '#disabled',
  //       icon: ICONS.disabled,
  //       disabled: true,
  //     },

  //     {
  //       title: 'item_label',
  //       path: '#label',
  //       icon: ICONS.label,
  //       info: (
  //         <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
  //           NEW
  //         </Label>
  //       ),
  //     },
  //     {
  //       title: 'item_caption',
  //       path: '#caption',
  //       icon: ICONS.menuItem,
  //       caption:
  //         'Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.',
  //     },
  //     {
  //       title: 'item_external_link',
  //       path: 'https://www.google.com/',
  //       icon: ICONS.external,
  //     },
  //     {
  //       title: 'blank',
  //       path: PATH_DASHBOARD.blank,
  //       icon: ICONS.blank,
  //     },
  //   ],
  // },
];

export default navConfig;
